import { Button, Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ConfirmFormProps {
  message: string;
  yesCallback: () => void;
  noCallback: () => void;
  commonCallback?: () => void;
}

export const ConfirmForm = (params: ConfirmFormProps) => {
  const { message, yesCallback, noCallback, commonCallback = () => {} } = params;
  const { t } = useTranslation();

  const callback = async (callbackFn: () => void) => {
    await commonCallback();
    await callbackFn();
  };

  return (
    <Flex w="30rem" mih="6rem" direction="column" gap="sm" justify="space-between">
      <Text
        style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
        size="1.6rem"
      >
        {message}
      </Text>
      <Flex gap="md" justify="flex-end">
        <Button color="red" size="md" onClick={() => callback(noCallback)}>
          {t("common.no")}
        </Button>
        <Button size="md" onClick={() => callback(yesCallback)}>
          {t("common.yes")}
        </Button>
      </Flex>
    </Flex>
  );
};
